import { BrowserRouter as Router } from "react-router-dom";
import { setConfiguration } from "react-grid-system";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./styles/GlobalStyles";
import { theme } from "./styles/theme";
import { AppProvider } from "./context/appContext";
import { Page } from "./layouts/Page";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/authContext";
import { SearchProvider } from "./context/search";

setConfiguration({
	maxScreenClass: "xxxl",
	gutterWidth: 16,
	breakpoints: [576, 768, 992, 1200, 1366, 1920],
	containerWidths: [540, 740, 960, 1140, 1256, 1810],
});

const queryClient = new QueryClient();

function App() {
	return (
		<HelmetProvider>
			<AuthProvider>
				<AppProvider>
					<SearchProvider>
						<QueryClientProvider client={queryClient}>
							<ThemeProvider theme={theme}>
								<Router
									future={{
										v7_startTransition: true,
										v7_relativeSplatPath: true
									}}
								>
									<Helmet>
										<link rel="stylesheet" href="https://use.typekit.net/gaj3nyb.css" />
									</Helmet>
									<Page />
									<ToastContainer position="bottom-right" autoClose={5000} newestOnTop={false} closeOnClick draggable pauseOnHover />
								</Router>
								<GlobalStyles />
							</ThemeProvider>
							{/*process.env.NODE_ENV === "development" && <ReactQueryDevtools />*/}
						</QueryClientProvider>
					</SearchProvider>
				</AppProvider>
			</AuthProvider>
		</HelmetProvider>
	);
}

export default App;
